let base = {}

// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符， 
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字) 
// 例子： 
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423 
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18 
Date.prototype.format = function (fmt) {
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "h+": this.getHours(), //小时 
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

base.if_isBigImg = function (url,isBig = false) {
	// console.log(url,'图片链接')
	let w_1080 = `x-oss-process=image/resize,w_1080`,
		w_240 = `x-oss-process=image/resize,w_240`;
	
	var start = url.indexOf('?');//获得字符串的开始位置
	// console.log(start,'获得字符串的开始位置')
	
	if(isBig == false){ //默认是小图
		if(start != -1){ //有参数 
			// console.log('小图')
			var split = url.split('?'); //把一个字符串分割成字符串数组。
			// console.log(split,'把一个字符串分割成字符串数组')
			
			var result = `${split[0]}?${split[1]}`;
			// console.log(result,'小图拼接字符串1')
		}else{ //没参数
			var result = `${url}?${w_240}`;
			// console.log(result,'小图拼接字符串2')
		}
	}else{ //大图
		// console.log('大图')
		if(start != -1){ //有参数 
			var split = url.split('?'); //把一个字符串分割成字符串数组。
			// console.log(split,'把一个字符串分割成字符串数组')
			
			var result = `${split[0]}?${split[1]}`;
			// console.log(result,'大图拼接字符串1')
		}else{ //没参数
			var result = `${url}?${w_1080}`;
			// console.log(result,'大图拼接字符串2')
		}
	}
	
	return result;
}


export default base



// WEBPACK FOOTER //
// ./src/assets/js/base.js